import find from 'lodash/find'

import SurveyValue from './SurveyValue'

import shouldersAverage from '../../../svg/shoulders-average.svg'
import shouldersBroader from '../../../svg/shoulders-broader.svg'
import shouldersSlimmer from '../../../svg/shoulders-slimmer.svg'

// NOTE: Do not use class directly except to check for type!
class ShoulderShape extends SurveyValue {
  constructor({icon, key, title}) {
    super(key)

    this.icon = icon
    this.title = title
  }

  toLabel() {
    return this.title
  }

  static keyToObject(key) {
    return find(SHOULDER_SHAPES, {key}) // eslint-disable-line no-use-before-define
  }
}

// NOTE: These `key`s reflect what is stored on the server (but as numbers instead of strings).
export const SHOULDER_SHAPES = {
  BROADER: new ShoulderShape({
    key: '0',
    icon: shouldersBroader,
    title: 'Broader',
  }),
  AVERAGE: new ShoulderShape({
    key: '1',
    icon: shouldersAverage,
    title: 'Average',
  }),
  SLIMMER: new ShoulderShape({
    key: '2',
    icon: shouldersSlimmer,
    title: 'Slimmer',
  }),
}

export default ShoulderShape
